







import {Vue,Component,Prop} from 'vue-property-decorator';
import store from '@/store';
@Component
export default class TableRowContainerMobile extends Vue{
    @Prop() rowIndex?: number;
    @Prop() tableName?: string;
    removeRow(){
        //alert(this.rowIndex);
        store.state.eventHub.$emit('table-row-removed',{tableName: this.tableName, rowIndex: this._rowIndex});
        this.$destroy();
        this.$el.remove();
    }
    _rowIndex = 0;
    created(){
        if(this.rowIndex)
            this._rowIndex = this.rowIndex;
        //console.log(this.rowIndex);
    }
}

